// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"552bd50c","498":"ff548d0e","703":"b62af240","787":"1e4b9ea2"}[chunkId] + ".chunk.js";
};